import { Observable } from '@helpcenter/epics-rxjs';
import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';
import { OPERATIONAL_EVENT_TYPE } from '@atlassian/analytics-web-react';
import { sendEvent } from '@atlassian/help-center-common-util/analytics';

export const fetchAwsWafToken = (
	createAnalyticsEvent?: CreateUIAnalyticsEvent,
): Observable<string | undefined> => {
	try {
		if (
			typeof AwsWafIntegration !== 'undefined' &&
			typeof AwsWafIntegration.getToken === 'function'
		) {
			return Observable.from(AwsWafIntegration.getToken());
		}
		sendFailToFetchWafTokenEvent(FailureType.JS_NOT_LOAD, createAnalyticsEvent);
		return Observable.of(undefined);
	} catch (error) {
		sendFailToFetchWafTokenEvent(FailureType.UNKNOWN_ERROR, createAnalyticsEvent);
		return Observable.of(undefined);
	}
};

const sendFailToFetchWafTokenEvent = (
	failureType: FailureType,
	createAnalyticsEvent?: CreateUIAnalyticsEvent,
) => {
	const trackEvent = createAnalyticsEvent?.({
		analyticsType: OPERATIONAL_EVENT_TYPE,
		action: 'failed',
		actionSubject: 'fetchWafToken',
		attributes: {
			failureType,
		},
	});
	trackEvent && sendEvent(trackEvent);
};

// oxlint-disable-next-line no-shadow
const enum FailureType {
	JS_NOT_LOAD = 'js.not.load',
	UNKNOWN_ERROR = 'unknown.error',
}
